import {TrackMixAudioSync} from '@spout/any-shared/models';
import {WaveformValues} from './store-models/audio-buffer-data.model';

export interface WaveformValuesTrackMixAudioSync {
  waveformValues: WaveformValues | null;
  trackMixAudioSync: TrackMixAudioSync;
}
